import { DisplayPrice } from '@/shared/components/display-price';
import { CartDataPrice } from '@/shared/types/prices';

type PriceDisplayProps = {
  price: CartDataPrice;
};

export const GamePriceDisplay = ({ price }: PriceDisplayProps) => {
  if (!price) return null;

  const { type, currencyCode, value, previousValue } = price;

  return (
    <div className='text-primary flex flex-wrap items-end justify-between pt-1'>
      {type === 'sale' && (
        <p className='flex flex-col gap-1'>
          <span className='line-through opacity-50'>
            <DisplayPrice value={previousValue ?? 0} currencyCode={currencyCode} />
          </span>
          <span className='text-primary text-base font-semibold'>
            <DisplayPrice value={value} currencyCode={currencyCode} />
          </span>
        </p>
      )}

      {type !== 'sale' && (
        <DisplayPrice
          className='text-primary text-base font-semibold'
          value={value}
          currencyCode={currencyCode}
        />
      )}
    </div>
  );
};
